/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiAiProviderConnectionsOpenaiCodexOauthCallbackParams,
  ImportLocalRequest,
  OAuthStartRequest,
  OAuthStatusRequest
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPostApiAiProviderConnectionsOpenaiCodexOauthStartUrl = () => {




  return `/api/ai-provider-connections/openai-codex/oauth/start`
}

export const postApiAiProviderConnectionsOpenaiCodexOauthStart = async (oAuthStartRequestNull: OAuthStartRequest | null, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getPostApiAiProviderConnectionsOpenaiCodexOauthStartUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oAuthStartRequestNull,)
  }
);}




export const getPostApiAiProviderConnectionsOpenaiCodexOauthStartMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexOauthStart>>, TError,{data: OAuthStartRequest | null}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexOauthStart>>, TError,{data: OAuthStartRequest | null}, TContext> => {

const mutationKey = ['postApiAiProviderConnectionsOpenaiCodexOauthStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexOauthStart>>, {data: OAuthStartRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiAiProviderConnectionsOpenaiCodexOauthStart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAiProviderConnectionsOpenaiCodexOauthStartMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexOauthStart>>>
    export type PostApiAiProviderConnectionsOpenaiCodexOauthStartMutationBody = OAuthStartRequest | null
    export type PostApiAiProviderConnectionsOpenaiCodexOauthStartMutationError = unknown

    export const usePostApiAiProviderConnectionsOpenaiCodexOauthStart = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexOauthStart>>, TError,{data: OAuthStartRequest | null}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexOauthStart>>,
        TError,
        {data: OAuthStartRequest | null},
        TContext
      > => {
      return useMutation(getPostApiAiProviderConnectionsOpenaiCodexOauthStartMutationOptions(options), queryClient);
    }
    export const getPostApiAiProviderConnectionsOpenaiCodexOauthStatusUrl = () => {




  return `/api/ai-provider-connections/openai-codex/oauth/status`
}

export const postApiAiProviderConnectionsOpenaiCodexOauthStatus = async (oAuthStatusRequest: OAuthStatusRequest, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getPostApiAiProviderConnectionsOpenaiCodexOauthStatusUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oAuthStatusRequest,)
  }
);}




export const getPostApiAiProviderConnectionsOpenaiCodexOauthStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexOauthStatus>>, TError,{data: OAuthStatusRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexOauthStatus>>, TError,{data: OAuthStatusRequest}, TContext> => {

const mutationKey = ['postApiAiProviderConnectionsOpenaiCodexOauthStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexOauthStatus>>, {data: OAuthStatusRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiAiProviderConnectionsOpenaiCodexOauthStatus(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAiProviderConnectionsOpenaiCodexOauthStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexOauthStatus>>>
    export type PostApiAiProviderConnectionsOpenaiCodexOauthStatusMutationBody = OAuthStatusRequest
    export type PostApiAiProviderConnectionsOpenaiCodexOauthStatusMutationError = unknown

    export const usePostApiAiProviderConnectionsOpenaiCodexOauthStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexOauthStatus>>, TError,{data: OAuthStatusRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexOauthStatus>>,
        TError,
        {data: OAuthStatusRequest},
        TContext
      > => {
      return useMutation(getPostApiAiProviderConnectionsOpenaiCodexOauthStatusMutationOptions(options), queryClient);
    }
    export const getPostApiAiProviderConnectionsOpenaiCodexImportLocalUrl = () => {




  return `/api/ai-provider-connections/openai-codex/import-local`
}

export const postApiAiProviderConnectionsOpenaiCodexImportLocal = async (importLocalRequestNull: ImportLocalRequest | null, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getPostApiAiProviderConnectionsOpenaiCodexImportLocalUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      importLocalRequestNull,)
  }
);}




export const getPostApiAiProviderConnectionsOpenaiCodexImportLocalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexImportLocal>>, TError,{data: ImportLocalRequest | null}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexImportLocal>>, TError,{data: ImportLocalRequest | null}, TContext> => {

const mutationKey = ['postApiAiProviderConnectionsOpenaiCodexImportLocal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexImportLocal>>, {data: ImportLocalRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiAiProviderConnectionsOpenaiCodexImportLocal(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAiProviderConnectionsOpenaiCodexImportLocalMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexImportLocal>>>
    export type PostApiAiProviderConnectionsOpenaiCodexImportLocalMutationBody = ImportLocalRequest | null
    export type PostApiAiProviderConnectionsOpenaiCodexImportLocalMutationError = unknown

    export const usePostApiAiProviderConnectionsOpenaiCodexImportLocal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexImportLocal>>, TError,{data: ImportLocalRequest | null}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAiProviderConnectionsOpenaiCodexImportLocal>>,
        TError,
        {data: ImportLocalRequest | null},
        TContext
      > => {
      return useMutation(getPostApiAiProviderConnectionsOpenaiCodexImportLocalMutationOptions(options), queryClient);
    }
    export const getGetApiAiProviderConnectionsOpenaiCodexOauthCallbackUrl = (params?: GetApiAiProviderConnectionsOpenaiCodexOauthCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ai-provider-connections/openai-codex/oauth/callback?${stringifiedParams}` : `/api/ai-provider-connections/openai-codex/oauth/callback`
}

export const getApiAiProviderConnectionsOpenaiCodexOauthCallback = async (params?: GetApiAiProviderConnectionsOpenaiCodexOauthCallbackParams, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getGetApiAiProviderConnectionsOpenaiCodexOauthCallbackUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiAiProviderConnectionsOpenaiCodexOauthCallbackQueryKey = (params?: GetApiAiProviderConnectionsOpenaiCodexOauthCallbackParams,) => {
    return [
    `/api/ai-provider-connections/openai-codex/oauth/callback`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAiProviderConnectionsOpenaiCodexOauthCallbackQueryOptions = <TData = Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>, TError = unknown>(params?: GetApiAiProviderConnectionsOpenaiCodexOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAiProviderConnectionsOpenaiCodexOauthCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>> = ({ signal }) => getApiAiProviderConnectionsOpenaiCodexOauthCallback(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAiProviderConnectionsOpenaiCodexOauthCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>>
export type GetApiAiProviderConnectionsOpenaiCodexOauthCallbackQueryError = unknown


export function useGetApiAiProviderConnectionsOpenaiCodexOauthCallback<TData = Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>, TError = unknown>(
 params: undefined |  GetApiAiProviderConnectionsOpenaiCodexOauthCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAiProviderConnectionsOpenaiCodexOauthCallback<TData = Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>, TError = unknown>(
 params?: GetApiAiProviderConnectionsOpenaiCodexOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAiProviderConnectionsOpenaiCodexOauthCallback<TData = Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>, TError = unknown>(
 params?: GetApiAiProviderConnectionsOpenaiCodexOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAiProviderConnectionsOpenaiCodexOauthCallback<TData = Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>, TError = unknown>(
 params?: GetApiAiProviderConnectionsOpenaiCodexOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAiProviderConnectionsOpenaiCodexOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAiProviderConnectionsOpenaiCodexOauthCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






